import { render, staticRenderFns } from "./driverdetils.vue?vue&type=template&id=271c15fe&scoped=true&"
import script from "./driverdetils.vue?vue&type=script&lang=js&"
export * from "./driverdetils.vue?vue&type=script&lang=js&"
import style0 from "./driverdetils.vue?vue&type=style&index=0&id=271c15fe&lang=scss&scoped=true&"
import style1 from "./driverdetils.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c15fe",
  null
  
)

export default component.exports